<template>
  <div v-if="$auth.check()">
    <v-row align="center">
      <v-col>
        <h1>Jadius v1.1</h1>
      </v-col>
      <v-col cols="auto">
        <v-btn small text color="primary" @click="load()">
          <v-icon left small>mdi-refresh</v-icon>Atualizar
        </v-btn>
      </v-col>
    </v-row>

    <v-alert dense text type="warning" v-if="failed">
      Falha ao carregar alguns indicadores.
    </v-alert>

    <v-row>
      <v-col cols="12" sm="6" :md="12 / cards.length" v-for="card in cards" :key="card.title">
        <v-card outlined :to="card.to" class="text-center py-4">
          <v-icon size="40" color="primary">{{ card.icon }}</v-icon>
          <div class="text-h4 font-weight-light mt-2">
            <v-progress-circular
              v-if="card.value === null"
              indeterminate
              size="24"
              width="2"
              color="primary"
            ></v-progress-circular>
            <span v-else>{{ card.value }}</span>
          </div>
          <div class="text-subtitle-2 grey--text">{{ card.title }}</div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="subtitle-1">NAS cadastrados</v-card-title>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Apelido</th>
                <th v-if="$auth.check('ROLE_ADMIN')">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in nas" :key="item.id">
                <td>{{ item.nasname }}</td>
                <td>{{ item.shortname }}</td>
                <td v-if="$auth.check('ROLE_ADMIN')">
                  <v-btn small color="primary" @click="viewNas(item.id)">detalhes</v-btn>
                </td>
              </tr>
              <tr v-if="nas.length == 0">
                <td colspan="3">Nenhum NAS cadastrado</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="subtitle-1">Grupos RADIUS</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-1"
              color="primary"
              outlined
              v-for="item in groups"
              :key="item.groupname"
              @click="viewGroup(item.groupname)"
            >
              {{ item.groupname }}
            </v-chip>
            <span v-if="groups.length == 0">Nenhum grupo cadastrado</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../api/index.js";
import router from "../router/index.js";
export default {
  data: () => ({
    counters: {
      raduser: null,
      radgroup: null,
      nas: null,
      user: null
    },
    groups: [],
    nas: [],
    failed: false
  }),
  computed: {
    logged: function() {
      return this.$auth.check();
    },
    cards: function() {
      var list = [
        {
          title: "Usuários RADIUS",
          icon: "mdi-badge-account",
          value: this.counters.raduser,
          to: "/raduser"
        },
        {
          title: "Grupos RADIUS",
          icon: "mdi-cogs",
          value: this.counters.radgroup,
          to: "/radgroup"
        },
        {
          title: "NAS",
          icon: "mdi-server",
          value: this.counters.nas,
          to: "/nas"
        }
      ];
      if (this.$auth.check("ROLE_ADMIN")) {
        list.push({
          title: "Usuários do sistema",
          icon: "mdi-account-group",
          value: this.counters.user,
          to: "/user"
        });
      }
      return list;
    }
  },
  created: function() {
    if (this.$auth.check()) {
      this.load();
    }
  },
  watch: {
    // App.vue só resolve o remember() depois do created() desta tela,
    // então a carga acontece quando o login é confirmado.
    logged: function(value) {
      if (value) {
        this.load();
      }
    }
  },
  methods: {
    load: function() {
      this.failed = false;
      this.countRadUsers();
      this.listGroups();
      this.listNas();
      if (this.$auth.check("ROLE_ADMIN")) {
        this.listUsers();
      }
    },
    countRadUsers: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.counters.raduser = null;
      api
        .get("/raduser/count", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.counters.raduser = response.data;
        })
        .catch(function(error) {
          console.log(error);
          me.counters.raduser = "-";
          me.failed = true;
        });
    },
    listGroups: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.counters.radgroup = null;
      api
        .get("/radgroup", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.groups = response.data;
          me.counters.radgroup = me.groups.length;
        })
        .catch(function(error) {
          console.log(error);
          me.counters.radgroup = "-";
          me.failed = true;
        });
    },
    listNas: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.counters.nas = null;
      api
        .get("/nas", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.nas = response.data;
          me.counters.nas = me.nas.length;
        })
        .catch(function(error) {
          console.log(error);
          me.counters.nas = "-";
          me.failed = true;
        });
    },
    listUsers: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.counters.user = null;
      api
        .get("/user", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.counters.user = response.data.length;
        })
        .catch(function(error) {
          console.log(error);
          me.counters.user = "-";
          me.failed = true;
        });
    },
    viewGroup: function(id) {
      router.push({ path: `/radgroup/${id}` });
    },
    viewNas: function(id) {
      router.push({ path: `/nas/${id}` });
    }
  }
};
</script>
